export default __webpack_public_path__ + "static/media/DragoslavPavlovic.243369a9.jpg";